import React from 'react';
import { COLORS } from '../utils/colors.js';
import {
  StyledAlert,
  StyledContent,
  StyledTitle,
  StyledDescription
} from './AnnouncementBanner.styles.js';

const AnnouncementBanner = ({ title, description }) => {
  if (!title && !description) {
    return null;
  }

  return (
    <StyledAlert severity="info" variant="filled">
      <StyledContent>
        {title && (
          <StyledTitle
            component="span"
            variant="headerDescription"
            color={COLORS.white}
            fontWeight={700}>
            {title}
          </StyledTitle>
        )}
        {description && (
          <StyledDescription
            component="span"
            variant="smallText"
            color={COLORS.white}
            fontWeight={400}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </StyledContent>
    </StyledAlert>
  );
};

export default AnnouncementBanner;
